import { ReactComponent as CPUSvg } from "./cpu.svg";

const QuoteExpiredError = () => (
  <article className="vh-100 dt w-100">
    <div className="dtc v-mid tc white ph3 ph4-l">
      <h1 className="f1 lh-title near-black">Application Expired</h1>
      <CPUSvg />
      <div className="center tc mw7">
        <p className="f3 lh-copy near-black measure">
          This insurance application has expired. Please create a new application for your work assignment to get started.
        </p>
      </div>
    </div>
  </article>
);

export default QuoteExpiredError; 